import { Icon } from '@zambezi/sdk/icons';
import React from 'react';
import './Disclaimer.scss';

interface DisclaimerProps extends React.HTMLProps<HTMLDivElement> {
  children: React.ReactNode | React.ReactNode[];
}

const Disclaimer = ({ children, ...rest }: DisclaimerProps) => {
  return (
    <div className="mss-disclaimer" {...rest}>
      <Icon name="core-notification-information-small" size="medium" title="" />
      <span>{children}</span>
    </div>
  );
};

export default Disclaimer;
